<mat-dialog-content>
  @if (expected_hours_year && viewDate && years) {
    <div class="row">
      <div class="col-9">
        <div class="d-flex align-items-center">
          <h2>{{ viewDate | calendarDate: 'monthViewTitle' : locale : weekStartsOn | titlecase }}</h2>

          @if (isManageForOthers) {
            <mat-form-field appearance="outline" class="nobottom" id="worker-selector">
              <mat-label>Trabajador</mat-label>
              <mat-select
                [ngModel]="$safeNavigationMigration(user?.id)"
                (ngModelChange)="onTargetUserSelected($event)"
                [disabled]="is_sending_request"
              >
                @for (worker of workers; track worker.id) {
                  <mat-option [value]="worker.id">{{ worker.name }} {{ worker.surnames }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <mat-form-field appearance="outline" class="nobottom" id="year-selector">
            <mat-label>Año imputable</mat-label>
            <mat-select [ngModel]="year" (ngModelChange)="onYearSelected($event)" [disabled]="is_sending_request">
              @for (year of years; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="btn-group">
            <button
              class="btn btn-primary"
              mwlCalendarPreviousView
              [view]="'month'"
              [(viewDate)]="viewDate"
              (click)="onChangeMonth()"
              [disabled]="prevMonthDisabled || is_sending_request"
            >
              Anterior
            </button>
            <button
              class="btn btn-outline-secondary"
              mwlCalendarToday
              [(viewDate)]="viewDate"
              [disabled]="todayDisabled || is_sending_request"
            >
              Hoy
            </button>
            <button
              class="btn btn-primary"
              mwlCalendarNextView
              [view]="'month'"
              [(viewDate)]="viewDate"
              (click)="onChangeMonth()"
              [disabled]="nextMonthDisabled || is_sending_request"
            >
              Siguiente
            </button>
          </div>
        </div>
        <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          [refresh]="refresh"
          (dayClicked)="dayClicked($event.day)"
          [locale]="locale"
          [weekStartsOn]="weekStartsOn"
          (eventClicked)="handleEvent('Clicked', $event.event)"
          (beforeViewRender)="beforeMonthViewRender($event)"
        ></mwl-calendar-month-view>
      </div>
      <div class="col-3">
        <div class="company_products-grid">
          @if (days_left != null && days_total != null) {
            <div class="company-product-card">
              <div class="company-product-spinner-container">
                <mat-progress-spinner color="accent" [mode]="'determinate'" [value]="spinner_prcnt" [diameter]="80"></mat-progress-spinner>
                <div
                  class="company-product-percentage company-product-percentage-centered"
                  [class.mt-1]="is_intern"
                  [style.font-size]="is_intern ? '2rem' : ''"
                >
                  @if (is_intern) {
                    ♾️
                  } @else {
                    {{ days_left | number: '1.0-0' }}/{{ days_total | number: '1.0-0' }}
                  }
                </div>
              </div>
              <div class="company-product-name">Días anuales restantes</div>
              <div class="company-product-status status-ok">✓ OK</div>
            </div>
          }
          @if (monthAvailabilityLoading) {
            <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
          }
          @if (!monthAvailabilityLoading && company_products.length > 0) {
            @for (company_product of company_products; track company_product.company_product_id) {
              <div class="company-product-card" [matTooltip]="getCompanyProductTooltip(company_product)" matTooltipPosition="above">
                <div class="company-product-spinner-container">
                  <mat-progress-spinner
                    color="accent"
                    [mode]="'determinate'"
                    [value]="getCompanyProductSpinnerPercentage(company_product)"
                    [diameter]="80"
                  >
                  </mat-progress-spinner>
                  <div class="company-product-logo">
                    @if (company_product.company_product_logo_url) {
                      <img [src]="company_product.company_product_logo_url" [alt]="company_product.company_product_name" />
                    } @else {
                      <div class="company-product-logo-placeholder">{{ company_product.company_product_name.charAt(0).toUpperCase() }}</div>
                    }
                  </div>
                  <div class="company-product-percentage">{{ company_product.current_percentage | number: '1.0-0' }}%</div>
                </div>
                <div class="company-product-name">{{ company_product.company_product_name }}</div>
                <div
                  class="company-product-status"
                  [class.status-ok]="company_product.status === 'OK'"
                  [class.status-limit]="company_product.status === 'LIMIT'"
                >
                  {{ company_product.status === 'OK' ? '✓ OK' : '⚠ LIMIT' }}
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" [disabled]="is_sending_request" (click)="viewPolicy()">Ver política de vacaciones</button>
  @if (vacation_request_periods_to_ask.length > 0) {
    <button mat-stroked-button [disabled]="is_sending_request" (click)="showRequestedDays()">Ver días solicitados</button>
  }
  <button mat-flat-button color="accent" [disabled]="reservarButtonDisabled" (click)="reservar()">
    @if (is_sending_request) {
      <mat-spinner [diameter]="20" mode="indeterminate" class="button-spinner"></mat-spinner>
      Procesando...
    } @else {
      Pedir vacaciones
    }
  </button>
</mat-dialog-actions>
